<script lang="ts" setup>
    import { ref, computed } from 'vue'

    const props = defineProps({
        voraussetzungenEcts: {
            type: String,
            required: true
        },
        allowEdit: {
            type: Boolean,
            required: false,
            default: false
        },
        tooltip: {
            type: String,
            required: false,
            default: () => ''
        },
        language: {
            type: String,
            required: false,
            default: () => 'deutsch'
        }
    })

    const title = computed(() =>
        props.language === 'englisch'
            ? 'Prerequisites for crediting | Voraussetzung für die Vergabe von ECTS'
            : 'Voraussetzung für die Vergabe von ECTS'
    )

    const emit = defineEmits(['voraussetzungenEctsSaved'])

    let editVoraussetzungenEcts = ref('')

    function handleEditStart() {
        editVoraussetzungenEcts.value = props.voraussetzungenEcts
    }

    function handleEditAbort() {
        editVoraussetzungenEcts.value = ''
    }

    const saveVoraussetzungenEcts = () => {
        emit('voraussetzungenEctsSaved', editVoraussetzungenEcts.value)
    }
</script>

<template>
    <common-single-edit
        :entry="voraussetzungenEcts"
        edit-key="voraussetzungenEcts"
        :title="title"
        :tool-tip="tooltip"
        :allow-edit="allowEdit"
        @text-saved="saveVoraussetzungenEcts"
        @edit-aborted="handleEditAbort"
        @edit-started="handleEditStart"
    >
        <template #edit-component>
            <common-my-markup-editor v-model:content="editVoraussetzungenEcts" />
        </template>
        <template #preview-component>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="voraussetzungenEcts" />
        </template>
    </common-single-edit>
</template>

<script></script>

<style scoped lang="scss"></style>
